<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h3>
    You've already updated your password.
    <br />
    If you forgot your password, please use the password reset option on the login page.
  </h3>
</div>
